import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

import aichuusim from "../../Assets/Projects/AichuuSim.png";
import aikids from "../../Assets/Projects/AiKidsSim.png";
import enstlive2d from "../../Assets/Projects/Live2DSim.png";
import sbntsim from "../../Assets/Projects/SBNTSim.png";
import kumafools from "../../Assets/Projects/KumaAprilFools.png";
import anstasearch from "../../Assets/Projects/AnstaSearch.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Projects <span className="wave" role="img" aria-labelledby="wave">🔧</span>
        </h1>
        <p className="green" style={{ fontWeight: "bold" }}>
          Here are projects I've worked on in the past years. There are more projects but unlisted for privacy reasons. I am also dataminer/developer for various fandoms at my own whims.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={enstlive2d}
              isBlog={false}
              title="Ensemble Stars! Live2D Viewer & Dialogue Simulator"
              description="L2D Viewer that can simulate dialogue. Functionality also includes screenshotting transparent Live2D renders. Supports (!) era models only."
              link="https://gradualcolors.github.io/l2d2-demo"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={anstasearch}
              isBlog={false}
              title="Ensemble Stars! Renders Search Tool"
              description="HTML5 + Javascript Search tool to find renders easier based on unit/subunit, character name, and event/gacha. Covers all version of Ensemble Stars. Data is manually updated."
              link="https://gradualcolors.github.io/ansta-search/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={sbntsim}
              isBlog={false}
              title="SubaNatsu ESO Visual Novel (Developer)"
              description="Web visual novel built on HTML + Javascript created for the enstars twitter community event 'Enstars Shipping Olympics'. Featuring the pair Subaru x Natsume. I was the developer behind the site, Byeol is the main artist, and Kari was responsible for storyboard. Might move this project to Github."
              link="http://subanatsu.elementfx.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={aichuusim}
              isBlog={false}
              title="Aichuu Scouting Simulator"
              description="Scouting Simulator for the now defunct mobile rhythm game I-CHU! Does not have all the card data and may update/refresh in the future as this was a very old project."
              link="http://aichuusim.x10host.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={aikids}
              isBlog={false}
              title="AiKids Scouting Simulator"
              description="AiKids version of the Scouting Simulator."
              link="http://aichuusim.x10host.com/ikids"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={kumafools}
              isBlog={false}
              title="Kumakocho Pinata Game"
              description="April fools game parody for I-CHU I made out of spite."
              link="http://aichuusim.x10host.com/kumapinata"
            />
          </Col>

        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
